<template>
  <div class="database-Backup">
    <main>

      <a-row style="padding:0 20px;">
        <a-form-model :model="sysSetForm" ref="sysSetForm"   :layout="formLayout"  style="margin-top: 15px">
              <a-col :span="24">
                <a-form-model-item label="是否启用" prop="screenRecord">
                  <a-switch v-model="sysSetForm.screenRecord" checked-children="开" un-checked-children="关"    @change="onchange" />
                </a-form-model-item>
              </a-col>
          <a-col :span="24" v-if="sysSetForm.screenRecord">
            <a-form-model-item label="备份周期" class="logo-item" prop="days"
                 :rules="[
                           {
                             required: true,
                             message: '不能为空',
                             trigger: 'blur'
                           },
                         ]">
              <label >每</label>
              <a-select v-model="sysSetForm.days" placeholder="请输入" style="width: 220px;padding: 0 10px"  >
                <a-select-option value="1">七天</a-select-option>
                <a-select-option value="2">一个月 </a-select-option>
                <a-select-option value="3">三个月 </a-select-option>
                <a-select-option value="4">半年 </a-select-option>
              </a-select>
              <label style="margin-left: 25px">备份一次</label>
            </a-form-model-item>

          </a-col>

          <a-col :span="24" class="sysSet-operate">
            <a-form-model-item >
              <a-button type="primary"  @click="fileSubmit" :loading="submitLoad" style="color: #ffffff">
                保存
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-form-model>
      </a-row>


    </main>
  </div>
</template>

<script>


export default {
  data() {
    return {
      btnLoad: false,
      submitLoad: false,
      formLayout: "inline",
      loading: false,
      sysSetForm:{
        days:undefined,
        screenRecord:false
      },

    };
  },
  methods: {

    // 监听开关
    onchange(val){
      if (val){
        this.sysSetForm.days = undefined
      }
    },

    // 保存
    fileSubmit(){
      this.$refs.sysSetForm.validate((valid) => {
        if (valid) {
          this.submitLoad = true;
          if (!this.sysSetForm.screenRecord ){
            this.sysSetForm.days = ''
          }
          let saveData = this.$lodash.cloneDeep(this.sysSetForm);
          this.axios
              .post('/setting/updateBackUpDBSetting',  saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  this.$message.success(res.message);
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

  },
  beforeMount(){
    this.axios
        .post("/setting/getBackUpDBSetting", )
        .then((res) => {
          if ( res.data.days == undefined ||  res.data.days == ''){
            this.sysSetForm.screenRecord = false
          }else{
            this.sysSetForm.screenRecord = true
          }
          this.sysSetForm.days = res.data.days ? res.data.days : '1'
        })
        .catch((err) => {
          console.log(err);
        });
  },
};
</script>

<style lang="scss" scoped>
.database-Backup {
  header {
    display: flex;
    align-items: flex-end;
    margin: -7px -8px 0;
    padding: 16px;
    letter-spacing: 1px;
    background-color: #fff;

    h3 {
      margin-bottom: 0;
      line-height: 20px;
      padding-left: 12px;
      border-left: 4px solid #3373f2;
      font-size: 18px;
      //font-weight: bold;
    }

    span {
      line-height: 16px;
      margin-left: 10px;
      color: #808080;
    }
  }

  main {
    margin: 16px 0px;
    background-color: #fff;
    //   padding: 0 16px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.07),
    0 1px 10px 0 rgba(0, 0, 0, 0.06);
    border-radius: 4px;


    ::v-deep .ant-form-item-label{
      font-weight: 600;
    }
    .ant-form-item label{
      font-weight: 600;
    }
    .logo-item{

      // 下拉框激活状态颜色
     ::v-deep .ant-select-selection {
        border-color: #fff;
        border-bottom-color: #40a9ff;
      }

      // 边框线颜色
      ::v-deep .ant-select-selection {
        border: none;
        border-radius: 0px;
        border-bottom: 1px solid #c7c7c7;
      }

      // 下拉框阴影
      ::v-deep .ant-select-selection--single {
        box-shadow: none;
      }

      ::v-deep .ant-select-selection__rendered{
        margin-left: 0px;
      }
      // 下拉框hover效果
      ::v-deep  .ant-select-selection:hover {
        border-color: #fff;
        border-bottom-color: #40a9ff;
        border-right-width: 1px !important;
      }



    }

    //按钮
    .sysSet-operate{
      text-align: right;
      margin: 385px 0 20px;
      .ant-btn:nth-child(1){
        margin-right: 15px;
        background-color: #ecf0fe;
        color: #3373f2;
        letter-spacing: 1px;
      }
      .ant-btn:nth-child(2){
        width: 70px;
      }
    }

  }
}
</style>
